import React from "react";
import * as Yup from "yup";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import { ERROR_MSG } from "./CommonUtils/contextVariables";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import { config } from "./CommonUtils/CommonURLS";
import { CommonAxiosPost } from "./CommonUtils/CommonAxios";
import allowNumbersOnly, {
    allowAlphabetAndSpacesOnly,
} from "./CommonUtils/CommonValidations";
import FacultyHeader from "./FacultyHeader";

export default function SubjectWiseFacultyData() {
    // ********** Validations ********
    const validationSchema = Yup.object({
        deptName: Yup.string().required(ERROR_MSG),
        sanctionedPosts: Yup.string().required(ERROR_MSG),
        regularFaculty: Yup.string().required(ERROR_MSG),
        contractFaculty: Yup.string().required(ERROR_MSG),
        guestFaculty: Yup.string().required(ERROR_MSG),
        adhocFaculty: Yup.string().required(ERROR_MSG),
    });

    // *********** Formik ********
    const facultySubjectDetailsFormik = useFormik({
        initialValues: {
            deptName: "",
            sanctionedPosts: "",
            regularFaculty: "",
            contractFaculty: "",
            guestFaculty: "",
            adhocFaculty: "",
        },
        validationSchema,
        onSubmit: (values) => {
            console.log("FORM VALUES 👉", values);
            // ✅ Prepare Payload
            const payload = {
                deptName: values?.deptName,
                noOfSanPosts: values?.sanctionedPosts,
                noOfRegFacWorking: values?.regularFaculty,
                noOfContractFacWorking: values?.contractFaculty,
                noOfGuestFacWorking: values?.guestFaculty,
                noOfAdhocFacWorking: values?.adhocFaculty,
            };
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to Submit?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Submit!",
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.FAC_URL}saveSubjectFacData`;
                    CommonAxiosPost(url, payload)
                        .then((res) => {
                            console.log("res?.data>>", res?.data);
                            if (res?.data?.scode === "01") {
                                Swal.fire(res?.data?.sdesc, "", "success").then(() => {
                                    facultySubjectDetailsFormik.resetForm();
                                });
                            } else {
                                Swal.fire(res?.data?.sdesc || "Submission failed", "", "error");
                            }
                        })

                }
            });
        },
    });

    return (
        <>
            <FacultyHeader />

            <div className="faculty-form-wrapper">
                <div className="faculty-card">

                    <h4 className="form-title">
                        Subject  Faculty Data
                    </h4>

                    <FormikProvider value={facultySubjectDetailsFormik}>
                        <Form>

                            <bie.Row>

                                {/* Department Name */}
                                <bie.Col lg={4} className="mb-3">
                                    <label>Name of the Department / Subject</label>
                                    <Field
                                        name="deptName"
                                        className="form-control"
                                        onKeyPress={allowAlphabetAndSpacesOnly}
                                        maxLength={100}
                                    />
                                    <ErrorMessage name="deptName" component="div" className="error-text" />
                                </bie.Col>

                                {/* Sanctioned Posts */}
                                <bie.Col lg={4} className="mb-3">
                                    <label>No of sanctioned posts (GO Ms No 95 dt 16-09-2023)</label>
                                    <Field
                                        name="sanctionedPosts"
                                        className="form-control"
                                        maxLength={4}
                                        onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="sanctionedPosts" component="div" className="error-text" />
                                </bie.Col>

                                {/* Regular Faculty */}
                                <bie.Col lg={4} className="mb-3">
                                    <label>No of regular faculty working</label>
                                    <Field
                                        name="regularFaculty"
                                        className="form-control"
                                        maxLength={4}
                                        onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="regularFaculty" component="div" className="error-text" />
                                </bie.Col>

                                {/* Contract Faculty */}
                                <bie.Col lg={4} className="mb-3">
                                    <label>No of contract faculty working</label>
                                    <Field
                                        name="contractFaculty"
                                        className="form-control"
                                        maxLength={4}
                                        onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="contractFaculty" component="div" className="error-text" />
                                </bie.Col>

                                {/* Guest Faculty */}
                                <bie.Col lg={4} className="mb-3">
                                    <label>No of Guest faculty working</label>
                                    <Field
                                        name="guestFaculty"
                                        className="form-control"
                                        maxLength={4}
                                        onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="guestFaculty" component="div" className="error-text" />
                                </bie.Col>

                                {/* Adhoc Faculty */}
                                <bie.Col lg={4} className="mb-3">
                                    <label>No of Adhoc faculty working</label>
                                    <Field
                                        name="adhocFaculty"
                                        className="form-control"
                                        maxLength={2}
                                        onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="adhocFaculty" component="div" className="error-text" />
                                </bie.Col>

                                <div className="text-end mt-4">
                                    <button type="submit" className="submit-btn">
                                        Submit
                                    </button>
                                </div>

                            </bie.Row>

                        </Form>
                    </FormikProvider>
                </div>
            </div>
        </>
    );
}